// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';

// Importing styles
import './styles/index.css';
import './styles/style.scss';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Any component wrapped in the "AuthContextProvider" will have access to the current user. Keeping it at top level here, will authenticate the entire app.
  <AuthContextProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AuthContextProvider>,
);
